export default "__VITE_ASSET__4b0eexk6__"